export default "__VITE_ASSET__a49225d5__"